























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { dictServe, performanceServer } from '@/api/installServer';

@Component({
  components: {},
  mixins: [TableStripe],
})
export default class AddDialog extends Vue {
  private visible = false;
  fileList: any = [];
  type: any = '';
  canEdit = false; // 详情的时候不可编辑
  assessTypeList: any = []; // 考核类型
  assessProjectList: any = []; // 考核项目

  formData: any = {
    id: '',
    checkDepartmentId: '',
    checkDepartmentName: '',
    remark: '',
  };

  userRules: any = {
    assessType: [{ required: true, trigger: 'blur', message: '请选择考核类型' }],
    assessProject: [{ required: true, trigger: 'blur', message: '请选择考核项目' }],
    assessStand: [{ required: true, trigger: 'blur', message: '请填写考核标准' }],
    assessContent: [{ required: true, trigger: 'blur', message: '请填写考核内容' }],
    assessMoney: [{ required: true, trigger: 'blur', message: '请填写处罚金额' }],
  };

  private async showAddDialog(type: any, data?: any) {
    this.type = type;
    this.visible = true;
    if (this.type === 'detail') {
      this.formData = data;
      this.canEdit = true;
    } else {
      this.canEdit = false;
      this.getDictDataByName('assessType');
      this.getDictDataByName('safeProductionAssessProject');
      if (this.type === 'add') {
        this.formData = {
          assessType: '',
          assessProject: '',
          assessStand: '',
          assessContent: '',
          assessMoney: '',
          remark: '',
        };
      } else {
        this.formData = data;
      }
    }
  }

  /**
   * @description 点击返回按钮 关闭弹窗
   */
  closeDialog() {
    this.formData = {
      assessType: '',
      assessProject: '',
      assessStand: '',
      assessContent: '',
      assessMoney: '',
      remark: '',
    };
    this.assessTypeList = [];
    this.visible = false;
    this.canEdit = false;
  }

  /**
   * @description 点击保存按钮
   */
  saveDialog() {
    const formComponent: any = this.$refs.form;
    formComponent.validate((valid: any) => {
      if (valid) {
        switch (this.type) {
          case 'add':
            this.saveFunctionData();
            break;
          case 'edit':
            this.saveFunctionData();
        }
      }
    });
  }

  /**
   * 【接口】行内新增功能
   */
  private async saveFunctionData() {
    // console.log(this.type);
    // console.log(this.formData);
    if (this.type === 'add') {
      await performanceServer
        .addAssessStandConfig({ ...this.formData })
        .then((res: any) => {
          this.$message.success('成功新增了一条数据！');
          this.closeDialog();
          this.$emit('refreshData');
        })
        .catch((error: any) => {
          // console.log(error);
          this.$message.warning('新增数据失败！');
        });
    }
    if (this.type === 'edit') {
      await performanceServer
        .modifyAssessStandConfig({ ...this.formData })
        .then((res: any) => {
          this.$message.success('成功修改当前数据！');
          this.closeDialog();
          this.$emit('refreshData');
        })
        .catch((error: any) => {
          // console.log(error);
          this.$message.warning('修改数据失败！');
        });
    }
  }

  // 考核项目
  private getDictDataByName(name: any) {
    const helpArr: any = [];
    dictServe
      .getDetailsMapByName(name)
      .then((res: any) => {
        if (res.code === '200' && res.data) {
          for (const key in res.data) {
            helpArr.push({
              label: key,
              value: res.data[key],
            });
          }
          if (name === 'assessType') {
            this.assessTypeList = helpArr;
          } else if (name === 'safeProductionAssessProject') {
            this.assessProjectList = helpArr;
          }
        }
      })
      .catch((error: any) => {
        this.$message.warning('获取数据失败！');
      });
  }

  // todo 还没完全写好的 适用机构(考核部门)
  // private getByDepartments(assessType: any) {
  //   performanceServer.getByDepartments({
  //     assessType: assessType,
  //   }).then((res: any) => {
  //     console.log(res);
  //   });
  // }
}
